module.exports = __webpack_public_path__ + "fonts/Rubik-400-cyrillic66.3ecd4ac.woff2";